module.exports = __webpack_public_path__ + "static/showroom2-50c11cbff9ce79c4c9a385526ba9c697.jpg";